import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const DEFAULT_URL = "";

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const ENTER_SITE_URL = "https://a.ntrk2.com/a9be36b4-7006-4932-99fc-28feb8223955";

export * from "./codes";
export * from "./context";
export const DOWNLOAD_URL = "https://ezjili.kzw2a.com/download?openExternalBrowser=1&id=xizrhpoxwe69gv8";
